export enum WidgetType {
	// For Users
	APPLICATIONS_PORTAL = 'applications-portal-widget',
	OUTBOUND_APPLICATIONS = 'outbound-applications-widget',
	USER_PROFILE = 'user-profile-widget',

	// For Admins
	ACCESS_KEY_MANAGEMENT = 'access-key-management-widget',
	AUDIT_MANAGEMENT = 'audit-management-widget',
	ROLE_MANAGEMENT = 'role-management-widget',
	TENANT_PROFILE = 'tenant-profile-widget',
	USER_MANAGEMENT = 'user-management-widget'
}

export type Widget = {
	type: WidgetType;
	id: string;
	name: string;
	path: string;
};

export interface ProjectWidgetListItem {
	name: string;
	type: string;
	widgetId: string;
	disabled: boolean;
	requiredPermissions?: string[];
}

export interface ListWidgetsResponse {
	widgets: ProjectWidgetListItem[];
}
